/**
 * Menús de la cabecera comercial:
 *
 *  - initMegaMenu: desplegable «Plataforma» (escritorio). Se abre con clic o
 *    al pasar el ratón; se cierra con Escape, clic fuera o al salir el ratón.
 *    Sin JS el disparador es un enlace normal a /plataforma.
 *  - initMenuMovil: botón hamburguesa por debajo de lg.
 *
 * Marcado en app/Modules/Plataforma/Views/partials/front_mega_menu.blade.php
 * y front_menu_movil.blade.php.
 */

const RETARDO_CIERRE = 160;

function initMegaMenu() {
    document.querySelectorAll('[data-mega]').forEach((mega) => {
        const disparador = mega.querySelector('[data-mega-trigger]');
        const panel = mega.querySelector('[data-mega-panel]');
        if (!disparador || !panel) {
            return;
        }

        let temporizador = null;
        const ratonFino = window.matchMedia('(hover: hover) and (pointer: fine)');

        const abrir = () => {
            clearTimeout(temporizador);
            panel.hidden = false;
            disparador.setAttribute('aria-expanded', 'true');
        };
        const cerrar = () => {
            clearTimeout(temporizador);
            panel.hidden = true;
            disparador.setAttribute('aria-expanded', 'false');
        };
        const cerrarLuego = () => {
            clearTimeout(temporizador);
            temporizador = setTimeout(cerrar, RETARDO_CIERRE);
        };

        disparador.addEventListener('click', (evento) => {
            evento.preventDefault();
            if (panel.hidden) {
                abrir();
            } else {
                cerrar();
            }
        });

        mega.addEventListener('mouseenter', () => {
            if (ratonFino.matches) {
                abrir();
            }
        });
        mega.addEventListener('mouseleave', () => {
            if (ratonFino.matches) {
                cerrarLuego();
            }
        });

        document.addEventListener('click', (evento) => {
            if (!panel.hidden && !mega.contains(evento.target)) {
                cerrar();
            }
        });
        document.addEventListener('keydown', (evento) => {
            if (evento.key === 'Escape' && !panel.hidden) {
                cerrar();
                disparador.focus();
            }
        });
        // Al tabular fuera del panel, se cierra.
        mega.addEventListener('focusout', (evento) => {
            if (!panel.hidden && evento.relatedTarget && !mega.contains(evento.relatedTarget)) {
                cerrar();
            }
        });
    });
}

function initMenuMovil() {
    const boton = document.querySelector('[data-menu-movil]');
    const panel = document.querySelector('[data-menu-movil-panel]');
    if (!boton || !panel) {
        return;
    }

    const iconoAbrir = boton.querySelector('[data-icono-abrir]');
    const iconoCerrar = boton.querySelector('[data-icono-cerrar]');

    const poner = (abierto) => {
        panel.hidden = !abierto;
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        boton.setAttribute('aria-label', abierto ? boton.dataset.labelCerrar : boton.dataset.labelAbrir);
        if (iconoAbrir && iconoCerrar) {
            iconoAbrir.toggleAttribute('hidden', abierto);
            iconoCerrar.toggleAttribute('hidden', !abierto);
        }
    };

    boton.addEventListener('click', () => poner(panel.hidden));

    // Los enlaces a anclas de la misma página (/#dudas…) no recargan: cerrar.
    panel.querySelectorAll('a').forEach((enlace) => {
        enlace.addEventListener('click', () => poner(false));
    });

    document.addEventListener('keydown', (evento) => {
        if (evento.key === 'Escape' && !panel.hidden) {
            poner(false);
            boton.focus();
        }
    });

    // Si se agranda la ventana hasta lg, el panel de móvil sobra.
    window.matchMedia('(min-width: 64rem)').addEventListener('change', (evento) => {
        if (evento.matches) {
            poner(false);
        }
    });
}

function boot() {
    initMegaMenu();
    initMenuMovil();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
    boot();
}
